/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import {
  Grid,
  FormControl,
  FormControlLabel,
  Button,
  RadioGroup,
  Radio,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core'
import '../Elegibilidad/Style/crearFormularioElegibilidad.scss'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
import NumberFormat from 'react-number-format'
import SaveIcon from '@material-ui/icons/Save'
import { useFormElegibilidad } from '../../../context/ElegibilidadContext'
import { useHistory } from 'react-router-dom'
import { genero } from '../data/data'
import { saveElegibilityForm } from '../../../services/Elegibilidad/create'
import { useEligibility } from '../../../context/EligibilityContext'
import { LoadingButton } from '@mui/lab'

const ElegibilidadSec2 = (props) => {
  const history = useHistory()
  const { goToStep } = props
  const { setEligibilityForm, EligibilityForm, idElegibilityForm } =
    useFormElegibilidad()
  const {
    IdLegalRepresentative,
    LegalRepresentativeName,
    Sector,
    MiPymeName,
    MiPymeCountry,
  } = EligibilityForm
  const [loadingSave, setLoadingSave] = useState(false)
  const [state, dispatch] = useEligibility()
  const [loading, setLoading] = useState(false)
  const [ready, setReady] = useState(false)
  const [
    showAffectsCulturalHeritageDetail,
    setShowAffectsCulturalHeritageDetail,
  ] = useState(false)
  const [error23, setError23] = useState(false)
  const [error291, setError291] = useState(false)

  const Seccion2DataSchema = Yup.object().shape({
    IsNativeCommunity: Yup.boolean().required('Este campo es obligatorio'),

    Gender: Yup.string().required('Este campo es obligatorio'),
    Position: Yup.string()
      .required('Este campo es obligatorio')
      .max(60, 'Máximo 60 caracteres')
      .matches(
        /^[-()#,.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      ),
    NativeCommunity: Yup.string()
      .max(60, 'Máximo 60 caracteres')
      .when('IsNativeCommunity', {
        is: true,
        then: Yup.string().required('Este campo es obligatorio'),
      })
      .matches(
        /^[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      ),
    WomenEmployees: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    MenEmployees: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    WomenCountHighDirection: Yup.number()
      .required('Este campo es obligatorio')
      .test(
        'superior',
        'No debe ser mayor a la cantidad de mujeres empleadas ',
        function (f) {
          const ref = Yup.ref('WomenEmployees')
          return f <= this.resolve(ref)
        },
      ),
    EmployessValidation: Yup.number()
      .max(
        EligibilityForm.TotalEmployees,
        'El número de empleados de mujeres y hombres no debe ser mayor al  total de empleados ',
      )
      .min(
        EligibilityForm.TotalEmployees,
        'El número de empleados de mujeres y hombres no debe ser menor al total de empleados ',
      ),
    IdLandTenancy: Yup.string().required('Este campo es obligatorio'),
  })

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      Gender: '',
      Position: '',
      IdSector: '',
      IdMipymeType: '',
      TotalMembers: 0,
      WomenCount: 0,
      MenCount: 0,
      WomenEmployees: null,
      MenEmployees: null,
      IsNativeCommunity: '',
      IdLandTenancy: '',
      WomenCountBoardsD: 0,
      WomenCountHighDirection: 0,
      WomenCountOwnerSociety: 0,
      NativeCommunity: '',

      Draft: true,
    },
    validationSchema: Seccion2DataSchema,

    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  const saveForm = async (values, borrador, exit) => {
    setLoadingSave(true)
    try {
      let object = { ...EligibilityForm, ...values }
      if (borrador) {
        object = {
          ...object,
          IdLandTenancy:
            values.IdLandTenancy === '' ? null : values.IdLandTenancy,
          IsNativeCommunity:
            values.IsNativeCommunity === '' ? null : values.IsNativeCommunity,
        }
      }
      const response = await saveElegibilityForm({
        ...object,
        IdFormAction: 24,
      })
      if (response.Success) {
        saveToContext(values)

        if (borrador) {
          setLoadingSave(false)
          swal({
            title: 'Formulario Guardado',
            icon: 'success',
            button: 'Entendido',
          })
          if (exit) {
            history.push('/')
            setEligibilityForm([])
          }
        } else {
          setLoadingSave(false)
          next()
        }
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      setLoadingSave(false)
      console.log(error.message)
    }
  }

  const saveToContext = (values) => {
    setEligibilityForm((prev) => {
      const valores = {
        Gender: values.Gender,
        Position: values.Position,
        TotalMembers: values.TotalMembers,
        WomenCount: values.WomenCount,
        MenCount: values.MenCount,
        WomenEmployees: values.WomenEmployees,
        MenEmployees: values.MenEmployees,
        IsNativeCommunity: values.IsNativeCommunity,
        NativeCommunity: values.NativeCommunity,
        IdLandTenancy: values.IdLandTenancy,
        WomenCountBoardsD: values.WomenCountBoardsD,
        WomenCountHighDirection: values.WomenCountHighDirection,
        WomenCountOwnerSociety: values.WomenCountOwnerSociety,
      }
      return {
        ...prev,
        ...valores,
      }
    })
  }

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 3 })
    goToStep(3)
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROR: ', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  let TotalMembers = ''
  TotalMembers =
    Number(formik.values.WomenCount) + Number(formik.values.MenCount)
  const WomanPercent = (Number(formik.values.WomenCount) / TotalMembers) * 100
  const MenPercent = (Number(formik.values.MenCount) / TotalMembers) * 100

  const WomanEmployesPercent =
    (Number(formik.values.WomenEmployees) / EligibilityForm.TotalEmployees) *
    100
  const menEmployesPercent =
    (Number(formik.values.MenEmployees) / EligibilityForm.TotalEmployees) * 100

  const handleChangeCultural = (e) => {
    formik.setFieldValue('IsNativeCommunity', e.target.value, false)
    if (e.target.value === 'si') {
      setShowAffectsCulturalHeritageDetail(true)
      formik.setFieldValue('IsNativeCommunity', true)
    } else {
      setShowAffectsCulturalHeritageDetail(false)
      formik.setFieldValue('IsNativeCommunity', false)
      formik.setFieldValue('NativeCommunity', '')
    }
  }

  const handleChangeTenenciaTierra = (e) => {
    formik.setFieldValue('IdLandTenancy', e.target.value, false)
  }

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 1 })
    goToStep(1)
  }

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const exit = true
        saveForm(formik.values, true, exit)
      } else if (result.isDenied) {
        history.push('/')
        setEligibilityForm([])
      }
    })
  }

  return (
    <>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => cancelForm()}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        <Grid item>
          <div
            onClick={() => !loadingSave && saveForm(formik.values, true)}
            data-tip
            data-for="savePop"
            style={{
              backgroundColor: !loadingSave ? '#5cb85c' : 'gray',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <SaveIcon />
          </div>
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Guardar Borrador</span>
          </ReactTooltip>
        </Grid>
      </Grid>
      <br></br>
      <form id="evaluation-data-form" onSubmit={formik.handleSubmit}>
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">INFORMACIÓN SOBRE LA MIPYME</h1>
          <br />
        </Grid>
        <Grid container spacing={1}>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">2.1 Nombre de la MIPYME</label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeName"
                  style={{ width: '100%' }}
                  error={!!formik.errors.MiPymeName}
                  variant="outlined"
                  disabled
                  value={MiPymeName}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={8} sm={8} md={8}>
              <label className="responsiveLabel">
                2.2. Nombre del representante de la MIPYME
              </label>
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <label className="responsiveLabel">
                Género representante legal:{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={8} sm={8} md={8}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="LegalRepresentativeNametxt"
                  style={{ width: '100%' }}
                  disabled
                  variant="outlined"
                  value={LegalRepresentativeName}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>

            <Grid item xs={4} sm={4} md={4}>
              <FormControl fullWidth>
                <Select
                  id="Gender"
                  variant="outlined"
                  error={formik.errors.Gender}
                  value={formik.values.Gender}
                  onChange={(e) => {
                    formik.setFieldValue('Gender', e.target.value, false)
                    if (e.target.value === 'Femenino') {
                      formik.setFieldValue('WomenCountOwnerSociety', 1, false)
                    } else {
                      formik.setFieldValue('WomenCountOwnerSociety', 0, false)
                    }
                  }}
                >
                  <MenuItem disabled value={''}>
                    Seleccione una opción
                  </MenuItem>
                  {genero &&
                    genero.map((item, key) => (
                      <MenuItem key={key} value={item} className="overFlowText">
                        {item}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.Gender ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.Gender}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2.3. Cargo del representante de la MIPYME
              </label>
              <a
                data-tip="Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, numeral, coma y punto."
                data-for="infoCurrencyPop"
                style={{ cursor: 'pointer' }}
              >
                <ErrorOutlineIcon fontSize="small" />
                <ReactTooltip
                  id="infoCurrencyPop"
                  effect="solid"
                  multiline={true}
                  type="dark"
                />
              </a>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="Position"
                  style={{ width: '100%' }}
                  error={formik.errors.Position}
                  variant="outlined"
                  inputProps={{
                    maxLength: 60,
                  }}
                  value={formik.values.Position}
                  onChange={(e) => {
                    if (
                      e.target.value.match(
                        /[-()#,.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                      ) ||
                      e.target.value === ''
                    ) {
                      setError23(false)
                      const value = e.target.value.trimStart()
                      formik.setFieldValue('Position', value, false)
                    } else {
                      setError23(true)
                    }
                  }}
                />
                {error23 ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    Caracteres especiales no aceptados
                  </div>
                ) : null}
                {formik.errors.Position ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.Position}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={6} md={6}>
              <label className="responsiveLabel">
                2.4. Sector productivo donde opera la MIPYME{' '}
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  id="Sector"
                  style={{ width: '100%' }}
                  variant="outlined"
                  disabled
                  value={Sector}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={6} md={6}>
              <label className="responsiveLabel">
                2.5. País donde se localiza la MIPYME
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  id="MiPymeCountry"
                  style={{ width: '100%' }}
                  variant="outlined"
                  disabled
                  value={MiPymeCountry}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={6} md={6}>
              <label className="responsiveLabel">
                2.6. Estatus legal de la MIPYME{' '}
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  id="MiPymeType"
                  style={{ width: '100%' }}
                  variant="outlined"
                  disabled
                  value={EligibilityForm.MiPymeType}
                />
              </FormControl>
            </Grid>
          </Grid>

          {EligibilityForm.MiPymeType !== 'Persona Natural' ? (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  2.7. Estatus asociativo de la MIPYME
                </label>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{ marginTop: '1%', marginBottom: '1%' }}
              >
                <label className="responsiveLabel">
                  Para MIPYME Asociativa, favor desagregar la siguiente
                  información
                </label>
              </Grid>

              <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
                <label className="responsiveLabel">
                  1. Número de mujeres socias:
                  <span style={{ color: 'red' }}>*</span>
                  <a
                    data-tip="Total de mujeres que son miembros o socios de la MIPYME."
                    data-for="infoCurrencyPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoCurrencyPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </label>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="fullName"
                    style={{ width: '100%' }}
                    error={formik.errors.WomenCount}
                    allowNegative={false}
                    allowLeadingZeros={false}
                    customInput={TextField}
                    variant="outlined"
                    format="###"
                    value={formik.values.WomenCount}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'WomenCount',
                        Number(e.target.value),
                        false,
                      )
                      if (EligibilityForm.MiPymeType !== 'Persona Natural') {
                        formik.setFieldValue(
                          'WomenCountOwnerSociety',
                          Number(e.target.value),
                          false,
                        )
                      }
                    }}
                  />
                  {formik.errors.WomenCount ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.WomenCount}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="WomanPercent"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    disabled
                    suffix="%"
                    value={
                      isNaN(WomanPercent.toFixed(0))
                        ? 0
                        : WomanPercent.toFixed(0)
                    }
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
                <label className="responsiveLabel">
                  2. Número de hombres socios:
                  <span style={{ color: 'red' }}>*</span>
                  <a
                    data-tip="Total de hombres que son miembros o socios de la MIPYME."
                    data-for="infoCurrencyPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoCurrencyPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </label>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="MenCount"
                    style={{ width: '100%' }}
                    error={formik.errors.MenCount}
                    customInput={TextField}
                    thousandSeparator={false}
                    allowNegative={false}
                    allowLeadingZeros={false}
                    format="###"
                    variant="outlined"
                    value={formik.values.MenCount}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'MenCount',
                        Number(e.target.value),
                        false,
                      )
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="fullName"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    disabled
                    suffix="%"
                    value={
                      isNaN(MenPercent.toFixed(0)) ? 0 : MenPercent.toFixed(0)
                    }
                  />
                  {formik.errors.MenCount ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.MenCount}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
                <label className="responsiveLabel">
                  3. Total de miembros o socios:
                </label>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    disabled
                    id="fullName"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    value={TotalMembers !== 0 ? TotalMembers : 0}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  2.7. Estatus asociativo de la MIPYME
                </label>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{ marginTop: '1%', marginBottom: '1%' }}
              >
                <label className="responsiveLabel">
                  Para MIPYME Asociativa, favor desagregar la siguiente
                  información
                </label>
              </Grid>

              <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
                <label className="responsiveLabel">
                  1. Número de mujeres socias:
                  <span style={{ color: 'red' }}>*</span>
                  <a
                    data-tip="Total de mujeres que son miembros o socios de la MIPYME."
                    data-for="infoCurrencyPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoCurrencyPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </label>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="fullName"
                    style={{ width: '100%' }}
                    error={formik.errors.WomenCount}
                    allowNegative={false}
                    customInput={TextField}
                    variant="outlined"
                    format="###"
                    disabled
                    value={formik.values.WomenCount}
                    onChange={(e) => {
                      formik.setFieldValue('WomenCount', e.target.value, false)
                      if (EligibilityForm.MiPymeType !== 'Persona Natural') {
                        formik.setFieldValue(
                          'WomenCountOwnerSociety',
                          e.target.value,
                          false,
                        )
                      }
                    }}
                    className="multilineTextField"
                  />
                  {formik.errors.WomenCount ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.WomenCount}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="fullName"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    disabled
                    suffix="%"
                    value={0}
                    className="multilineTextField"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
                <label className="responsiveLabel">
                  2. Número de hombres socios:
                  <span style={{ color: 'red' }}>*</span>
                  <a
                    data-tip="Total de hombres que son miembros o socios de la MIPYME."
                    data-for="infoCurrencyPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoCurrencyPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </label>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="MenCount"
                    style={{ width: '100%' }}
                    error={formik.errors.MenCount}
                    customInput={TextField}
                    thousandSeparator={false}
                    allowNegative={false}
                    allowLeadingZeros={false}
                    format="###"
                    variant="outlined"
                    disabled
                    value={formik.values.MenCount}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'MenCount',
                        Number(e.target.value),
                        false,
                      )
                    }}
                    className="multilineTextField"
                  />
                  {formik.errors.MenCount ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.MenCount}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="fullName"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    disabled
                    suffix="%"
                    // TODO: Revisar value.
                    value={0}
                    className="multilineTextField"
                  />
                  {formik.errors.MenCount ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.MenCount}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
                <label className="responsiveLabel">
                  3. Total de miembros o socios:
                </label>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    disabled
                    id="TotalMembers"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    value={0}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'TotalMembers',
                        e.target.value,
                        false,
                      )
                    }}
                    className="multilineTextField"
                  />
                </FormControl>
              </Grid>
            </Grid>
          )}

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2.8. Número de empleados de la MIPYME desagregados por género
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                1. Número de mujeres empleadas:
              </label>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="WomenEmployees"
                  style={{ width: '100%' }}
                  error={formik.errors.WomenEmployees}
                  allowNegative={false}
                  customInput={TextField}
                  allowLeadingZeros={false}
                  format="###"
                  variant="outlined"
                  value={formik.values.WomenEmployees}
                  onChange={(e) => {
                    const value = e.target.value === '' ? 0 : e.target.value
                    formik.setFieldValue(
                      'WomenEmployees',
                      parseInt(value),
                      false,
                    )
                    formik.setFieldValue(
                      'EmployessValidation',
                      parseInt(value) + formik.values.MenEmployees,
                    )
                  }}
                />
              </FormControl>
              {formik.errors.WomenEmployees ? (
                <div
                  style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                >
                  {formik.errors.WomenEmployees}
                </div>
              ) : null}
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="womenEmployeesPercent"
                  style={{ width: '100%' }}
                  customInput={TextField}
                  thousandSeparator={true}
                  variant="outlined"
                  disabled
                  suffix="%"
                  value={WomanEmployesPercent.toFixed(0)}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                2. Número de hombres empleados:
              </label>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="MenEmployees"
                  style={{ width: '100%' }}
                  error={formik.errors.MenEmployees}
                  customInput={TextField}
                  allowNegative={false}
                  allowLeadingZeros={false}
                  variant="outlined"
                  format="###"
                  value={formik.values.MenEmployees}
                  onChange={(e) => {
                    const value = e.target.value === '' ? 0 : e.target.value

                    formik.setFieldValue('MenEmployees', parseInt(value), false)
                    formik.setFieldValue(
                      'EmployessValidation',
                      formik.values.WomenEmployees + Number(value),
                    )
                  }}
                />

                {formik.errors.MenEmployees ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.MenEmployees}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="MenEmployees"
                  style={{ width: '100%' }}
                  customInput={TextField}
                  thousandSeparator={true}
                  variant="outlined"
                  disabled
                  suffix="%"
                  value={menEmployesPercent.toFixed(0)}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">3. Total de empleados:</label>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="fullName"
                  style={{ width: '100%' }}
                  error={formik.errors.TotalEmployees}
                  customInput={TextField}
                  thousandSeparator={true}
                  variant="outlined"
                  disabled
                  value={EligibilityForm.TotalEmployees}
                  className="multilineTextField"
                />
                {formik.errors.TotalEmployees ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.TotalEmployees}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>
          {formik.errors.EmployessValidation ? (
            <div style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}>
              {formik.errors.EmployessValidation}
            </div>
          ) : null}
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2.9. ¿La MIPYME pertenece a una comunidad indígena?{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  id="IsNativeCommunity"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={(e) => handleChangeCultural(e)}
                  row
                >
                  <FormControlLabel value="si" control={<Radio />} label="Si" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                {formik.errors.IsNativeCommunity ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.IsNativeCommunity}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          {showAffectsCulturalHeritageDetail && (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  2.9.1. ¿A qué etnia/pueblo/comunidad pertenece?
                </label>
                <a
                  data-tip="Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, numeral, coma y punto."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    id="detailActivity"
                    style={{ width: '100%' }}
                    error={formik.errors.NativeCommunity}
                    variant="outlined"
                    inputProps={{ autoComplete: 'off', maxLength: 60 }}
                    value={formik.values.NativeCommunity}
                    onChange={(e) => {
                      if (
                        e.target.value.match(
                          /[-()#,.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                        ) ||
                        e.target.value === ''
                      ) {
                        setError291(false)
                        formik.setFieldValue('NativeCommunity', e.target.value)
                      } else {
                        setError291(true)
                      }
                    }}
                  />
                  {error291 ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.NativeCommunity ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.NativeCommunity}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          )}

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2.10. Tenencia de la tierra{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
              <br></br>
              <label className="responsiveLabel">
                Detalle el tipo de tenencia de tierra de la MIPYME, y tipo de
                derechos sobre la misma:
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  id="IdLandTenancy"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={(e) => handleChangeTenenciaTierra(e)}
                >
                  <FormControlLabel
                    value="DF"
                    control={<Radio />}
                    label={
                      <>
                        Derechos formales
                        <a
                          data-tip="Posee un título de propiedad"
                          data-for="infoCurrencyPop"
                          style={{ cursor: 'pointer' }}
                        >
                          <ErrorOutlineIcon fontSize="small" />
                          <ReactTooltip
                            id="infoCurrencyPop"
                            effect="solid"
                            multiline={true}
                            type="dark"
                          />
                        </a>
                      </>
                    }
                  />
                  <FormControlLabel
                    value="DI"
                    control={<Radio />}
                    label={
                      <>
                        Derechos informales
                        <a
                          data-tip="No posee un título de propiedad"
                          data-for="infoCurrencyPop"
                          style={{ cursor: 'pointer' }}
                        >
                          <ErrorOutlineIcon fontSize="small" />
                          <ReactTooltip
                            id="infoCurrencyPop"
                            effect="solid"
                            multiline={true}
                            type="dark"
                          />
                        </a>
                      </>
                    }
                  />
                  <FormControlLabel
                    value="AR"
                    control={<Radio />}
                    label={
                      <>
                        Arrendatario
                        <a
                          data-tip="Paga una mensualidad por hacer uso de la propiedad"
                          data-for="infoCurrencyPop"
                          style={{ cursor: 'pointer' }}
                        >
                          <ErrorOutlineIcon fontSize="small" />
                          <ReactTooltip
                            id="infoCurrencyPop"
                            effect="solid"
                            multiline={true}
                            type="dark"
                          />
                        </a>
                      </>
                    }
                  />
                </RadioGroup>
                {formik.errors.IdLandTenancy ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.IdLandTenancy}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2.11. Liderazgo femenino en la MIPYME
              </label>
              <br></br>
            </Grid>
            <Grid
              item
              xs={6}
              sm={12}
              md={12}
              style={{ marginTop: '1%', marginBottom: '1%' }}
            >
              <label className="responsiveLabel">
                Proporcione la información a continuación:
              </label>
            </Grid>
            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                1. Cantidad de mujeres empleadas:
              </label>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                textAlign: 'right',
              }}
            >
              <FormControl style={{ width: '50%' }}>
                <NumberFormat
                  id="WomenEmployees"
                  style={{ width: '100%' }}
                  customInput={TextField}
                  thousandSeparator={true}
                  variant="outlined"
                  disabled
                  value={formik.values.WomenEmployees}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                2. Cantidad de mujeres en la Junta Directiva:
                <a
                  data-tip="Total de mujeres que integran la Junta Directiva."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                textAlign: 'right',
              }}
            >
              <FormControl
                style={{
                  width: '50%',
                }}
              >
                <NumberFormat
                  id="WomenCountBoardsD"
                  style={{ width: '100%' }}
                  error={formik.errors.WomenCountBoardsD}
                  customInput={TextField}
                  thousandSeparator={true}
                  variant="outlined"
                  allowLeadingZeros={false}
                  disabled={EligibilityForm.MiPymeType === 'Persona Natural'}
                  value={
                    EligibilityForm.MiPymeType !== 'Persona Natural'
                      ? formik.values.WomenCountBoardsD
                      : 0
                  }
                  onChange={(e) => {
                    formik.setFieldValue(
                      'WomenCountBoardsD',
                      parseInt(e.target.value),
                      false,
                    )
                  }}
                  className={
                    EligibilityForm.MiPymeType === 'Persona Natural'
                      ? 'multilineTextField'
                      : ''
                  }
                />

                {formik.errors.WomenCountBoardsD ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.WomenCountBoardsD}
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                3. Cantidad de mujeres en puestos de Alta Dirección:
                <a
                  data-tip="Total de mujeres que ocupan puestos gerenciales, jefaturas, o de asesoría."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                textAlign: 'right',
              }}
            >
              <FormControl style={{ width: '50%' }}>
                <NumberFormat
                  id="WomenCountHighDirection"
                  style={{ width: '100%' }}
                  error={formik.errors.WomenCountHighDirection}
                  customInput={TextField}
                  allowNegative={false}
                  format="###"
                  allowLeadingZeros={false}
                  variant="outlined"
                  value={formik.values.WomenCountHighDirection}
                  onChange={(e) => {
                    const value = e.target.value === '' ? 0 : e.target.value
                    formik.setFieldValue(
                      'WomenCountHighDirection',
                      Number(value),
                      false,
                    )
                  }}
                />
                {formik.errors.WomenCountHighDirection ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.WomenCountHighDirection}
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                4. Cantidad de mujeres propietarias/socias de la MIPYME:
              </label>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                textAlign: 'right',
              }}
            >
              <FormControl style={{ width: '50%' }}>
                {EligibilityForm.MiPymeType === 'Persona Natural' ? (
                  <NumberFormat
                    id="WomenCountOwnerSociety"
                    style={{ width: '100%' }}
                    error={formik.errors.WomenCountOwnerSociety}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    disabled
                    value={formik.values.Gender === 'Femenino' ? 1 : 0}
                    className="multilineTextField"
                  />
                ) : (
                  <NumberFormat
                    id="WomenCountOwnerSociety"
                    style={{ width: '100%' }}
                    error={formik.errors.WomenCountOwnerSociety}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    disabled
                    value={formik.values.WomenCount}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'WomenCountOwnerSociety',
                        e.target.value,
                        false,
                      )
                    }}
                    className="multilineTextField"
                  />
                )}
                {formik.errors.WomenCountOwnerSociety ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.WomenCountOwnerSociety}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="button__container">
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
                disabled={loading}
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                >
                  <LoadingButton
                    loading={loadingSave}
                    type="button"
                    onClick={() => validateFormStatus()}
                    className="button__wizard button__next"
                    variant="outlined"
                  >
                    Siguiente
                  </LoadingButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
export default ElegibilidadSec2
